import { useFirebase } from "@/composables/useFirebase";

export const useRateMessage = () => {
  const { logEvent } = useFirebase();

  const { postData } = useApi();

  const like = async (id: string) => {
    // Log event to firebase
    logEvent("like_message");
    // Send like to api
    await postData(`/chat-messages/${id}/like`);
  };

  const dislike = async (id: string) => {
    // Log event to firebase
    logEvent("dislike_message");
    // Send like to api
    await postData(`/chat-messages/${id}/dislike`);
  };

  return {
    like,
    dislike,
  };
};
